import { useNavigate } from 'react-router';

import { useTranslation } from '@gem/modules/i18n';

import {
  APP_LOGIN_CREATE_ACCOUNT_ROUTE,
  TAuthorizationRoutePath,
} from 'APP/router/AppRouter.authorizationRoutes';
import { RouterPage } from 'APP/router/constants';

interface ILoginOption {
  title: string;
  key: string;
  onClick(): void;
}

interface ILoginOptionsPresenter {
  options: ILoginOption[];
}

export function useLoginOptionsPresenter(): ILoginOptionsPresenter {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const APP_LOGIN_ROUTE_TITLE_MAP: Partial<Record<TAuthorizationRoutePath, string>> = {
    [RouterPage.LoginCreateAccount]: t('auth_create_team_button'),
  };

  const presenter = {
    get options(): ILoginOption[] {
      const routes = [APP_LOGIN_CREATE_ACCOUNT_ROUTE].filter((route) => route.isAvailable);

      return routes.map((route) => ({
        key: route.path,
        title: APP_LOGIN_ROUTE_TITLE_MAP[route.path] || '',
        onClick: (): void => {
          navigate(route.link);
        },
      }));
    },
  };

  return presenter;
}
